import type { ChannelDetails, ChannelEventDetails } from '../types';
import { NetchexNotificationChannels } from './NetchexNotificationChannels';
import { NetchexNotificationEvent } from './NotificationEvent/NetchexNotificationEvent';

const NetchexNotificationsIntent = ({
  isEmployeeNotificationSettings,
  channelDetailsArray,
  channelEventDetailsArray,
  refetch,
}: {
  isEmployeeNotificationSettings?: boolean;
  channelDetailsArray: ChannelDetails[];
  channelEventDetailsArray: ChannelEventDetails[];
  refetch: () => void;
}) => (
  <>
    <NetchexNotificationChannels
      isEmployeeNotificationSettings={isEmployeeNotificationSettings}
      channelDetailsArray={channelDetailsArray}
      channelEventDetailsArray={channelEventDetailsArray}
      refreshData={refetch}
    />
    <NetchexNotificationEvent
      isEmployeeNotificationSettings={isEmployeeNotificationSettings}
      channelDetailsArray={channelDetailsArray}
      channelEventDetailsArray={channelEventDetailsArray}
      refreshData={refetch}
    />
  </>
);

export { NetchexNotificationsIntent };
